import { useRef, useState } from "react";

/**
 * Assign state shared by the desktop and phone Today: which line is being
 * written, and the one-line outcome beside it. `onAssign(line, upn)` resolves
 * { ok, message }.
 */
export function useAssign(onAssign) {
  const [pendingKey, setPendingKey] = useState(null);
  const [results, setResults] = useState({});
  async function assign(line, upn) {
    setPendingKey(line.key);
    setResults((r) => ({ ...r, [line.key]: null }));
    let outcome;
    try {
      outcome = await onAssign(line, upn);
    } catch (err) {
      outcome = { ok: false, message: (err && err.message) || "request failed" };
    }
    setPendingKey(null);
    setResults((r) => ({ ...r, [line.key]: outcome && !outcome.ok ? outcome : null }));
  }
  return { pendingKey, results, assign };
}

/** The hidden file input behind "Upload a new list" / "Upload today's list". */
export function useUploadPicker({ canImport, onRefused, onFileChosen }) {
  const ref = useRef(null);
  function open() {
    if (!canImport) {
      if (onRefused) onRefused();
      return;
    }
    if (ref.current) ref.current.click();
  }
  function onChange(event) {
    const file = event.target.files && event.target.files[0];
    event.target.value = ""; // the same file can be chosen again after an error
    if (file && onFileChosen) onFileChosen(file);
  }
  return { ref, open, onChange };
}
